<h1>Administration des Entreprises</h1>
<pannel [title]="'Recherche'" [expandable]="true" [folded]="true">
	<entreprises-filters (filterRequest)="filters$.next($event)" ></entreprises-filters>
</pannel>
<pannel [expandable]="true" [title]="'Liste des entreprises'">
	<entreprises-table [filtersSubject]="filters$" ></entreprises-table>
</pannel>